import { render, staticRenderFns } from "./CollectionSearchResult.vue?vue&type=template&id=1442ba92&scoped=true&"
import script from "./CollectionSearchResult.vue?vue&type=script&lang=js&"
export * from "./CollectionSearchResult.vue?vue&type=script&lang=js&"
import style0 from "./CollectionSearchResult.vue?vue&type=style&index=0&id=1442ba92&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1442ba92",
  null
  
)

export default component.exports